var getPosition = function (position, trigger, target, offset, appendToBody) {
    if (offset === void 0) { offset = {
        vertical: 0,
        horizontal: 0,
    }; }
    var horizontalOffset = offset.horizontal, verticalOffset = offset.vertical;
    var pageYOffset = window.pageYOffset, pageXOffset = window.pageXOffset;
    var triggerCoordinates = trigger.getBoundingClientRect();
    var targetCoordinates = target.getBoundingClientRect();
    if (appendToBody) {
        switch (position) {
            case 'TopLeft': {
                return {
                    left: Math.round(triggerCoordinates.left + pageXOffset + horizontalOffset),
                    top: Math.round(triggerCoordinates.top +
                        pageYOffset -
                        (targetCoordinates.height + verticalOffset)),
                };
            }
            case 'TopCenter': {
                var xOffset = triggerCoordinates.left + triggerCoordinates.width / 2;
                return {
                    left: Math.round(xOffset +
                        pageXOffset +
                        horizontalOffset -
                        targetCoordinates.width / 2),
                    top: Math.round(triggerCoordinates.top +
                        pageYOffset -
                        (verticalOffset + targetCoordinates.height)),
                };
            }
            case 'TopRight': {
                return {
                    left: Math.round(triggerCoordinates.right +
                        pageXOffset +
                        horizontalOffset -
                        targetCoordinates.width),
                    top: Math.round(triggerCoordinates.top +
                        pageYOffset -
                        (verticalOffset + targetCoordinates.height)),
                };
            }
            case 'RightCenter': {
                return {
                    left: Math.round(triggerCoordinates.right + pageXOffset + horizontalOffset),
                    top: Math.round(triggerCoordinates.top +
                        pageYOffset +
                        verticalOffset +
                        triggerCoordinates.height / 2 -
                        targetCoordinates.height / 2),
                };
            }
            case 'BottomRight': {
                return {
                    left: Math.round(triggerCoordinates.right +
                        pageXOffset +
                        horizontalOffset -
                        targetCoordinates.width),
                    top: Math.round(triggerCoordinates.bottom + pageYOffset + verticalOffset),
                };
            }
            case 'BottomCenter': {
                var xOffset = triggerCoordinates.left + triggerCoordinates.width / 2;
                return {
                    left: Math.round(xOffset +
                        pageXOffset +
                        horizontalOffset -
                        targetCoordinates.width / 2),
                    top: Math.round(triggerCoordinates.bottom + pageYOffset + verticalOffset),
                };
            }
            case 'BottomLeft': {
                return {
                    left: Math.round(triggerCoordinates.left + horizontalOffset + pageXOffset),
                    top: Math.round(triggerCoordinates.bottom + pageYOffset + verticalOffset),
                };
            }
            case 'LeftCenter': {
                return {
                    left: Math.round(triggerCoordinates.left +
                        pageXOffset -
                        (horizontalOffset + targetCoordinates.width)),
                    top: Math.round(triggerCoordinates.top +
                        pageYOffset +
                        verticalOffset +
                        triggerCoordinates.height / 2 -
                        targetCoordinates.height / 2),
                };
            }
            default: {
                return {
                    left: Math.round(triggerCoordinates.right +
                        pageXOffset +
                        horizontalOffset -
                        targetCoordinates.width),
                    top: Math.round(triggerCoordinates.bottom + pageYOffset + verticalOffset),
                };
            }
        }
    }
    else {
        switch (position) {
            case 'TopLeft': {
                return {
                    left: Math.round(horizontalOffset),
                    top: -Math.round(targetCoordinates.height + verticalOffset),
                };
            }
            case 'TopCenter': {
                return {
                    left: Math.round((triggerCoordinates.width - targetCoordinates.width) / 2 +
                        horizontalOffset),
                    top: -Math.round(targetCoordinates.height + verticalOffset),
                };
            }
            case 'TopRight': {
                return {
                    left: triggerCoordinates.width -
                        targetCoordinates.width -
                        horizontalOffset,
                    top: -Math.round(targetCoordinates.height + verticalOffset),
                };
            }
            case 'RightCenter': {
                return {
                    left: triggerCoordinates.width + horizontalOffset,
                    top: Math.round(verticalOffset +
                        triggerCoordinates.height / 2 -
                        targetCoordinates.height / 2),
                };
            }
            case 'BottomRight': {
                return {
                    left: triggerCoordinates.width -
                        targetCoordinates.width -
                        horizontalOffset,
                    top: Math.round(verticalOffset + triggerCoordinates.height),
                };
            }
            case 'BottomCenter': {
                return {
                    left: Math.round((triggerCoordinates.width - targetCoordinates.width) / 2 +
                        horizontalOffset),
                    top: Math.round(verticalOffset + triggerCoordinates.height),
                };
            }
            case 'BottomLeft': {
                return {
                    left: horizontalOffset,
                    top: Math.round(verticalOffset + triggerCoordinates.height),
                };
            }
            case 'LeftCenter': {
                return {
                    left: -Math.round(horizontalOffset + targetCoordinates.width),
                    top: Math.round(verticalOffset +
                        triggerCoordinates.height / 2 -
                        targetCoordinates.height / 2),
                };
            }
            default: {
                return {
                    left: horizontalOffset,
                    top: Math.round(verticalOffset + triggerCoordinates.height),
                };
            }
        }
    }
};
var isInViewport = function (targetElement, position, appendToBody, triggerElement) {
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var pageYOffset = window.pageYOffset, pageXOffset = window.pageXOffset;
    var elementCoordinates = targetElement;
    var element = { left: 0, bottom: 0, right: 0, top: 0 };
    if (appendToBody) {
        element = {
            top: position.top - pageYOffset,
            left: position.left - pageXOffset,
            right: elementCoordinates.offsetWidth + position.left - pageXOffset,
            bottom: elementCoordinates.offsetHeight + position.top - pageYOffset,
        };
    }
    else if (triggerElement) {
        var triggerElementPosition = triggerElement.getBoundingClientRect();
        element = {
            top: triggerElementPosition.top + position.top,
            left: triggerElementPosition.left + position.left,
            right: triggerElementPosition.left +
                position.left +
                elementCoordinates.offsetWidth,
            bottom: triggerElementPosition.top +
                position.top +
                elementCoordinates.offsetHeight,
        };
    }
    if (element.top < 0) {
        return false;
    }
    if (element.bottom > windowHeight) {
        return false;
    }
    if (element.left < 0) {
        return false;
    }
    if (element.right > windowWidth) {
        return false;
    }
    return true;
};
export { getPosition, isInViewport };
//# sourceMappingURL=positionHelper.js.map